export const CART_REQUEST=`cart/request`;
export const CART_GET_SUCCESS=`cart/getsuccess`;
export const CART_POST_SUCCESS=`cart/postsuccess`;
export const CART_PATCH_SUCCESS=`cart/patchsuccess`;
export const CART_DELETE_SUCCESS=`cart/success`;
export const CART_FULL_EMPTY=`cart/success`;
export const CART_ERROR=`cart/error`;
